import { render, staticRenderFns } from "./orgAdd.vue?vue&type=template&id=6f3c3ac2"
import script from "./orgAdd.vue?vue&type=script&lang=js"
export * from "./orgAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports